import { connect } from "react-redux";
import { fetchMessageSettingGeneral, onChangeActive, onChangeText, onUpdate } from "../../../../store/action/messageSettingGeneralAction";
import { useEffect } from "react";
import SlateEditor from "../../../shared/components/SlateEditor/editor";
import { FULL_NAME, NAME, PAGE_NAME, SURNAME } from "../../../shared/components/SlateEditor/constant/constant";
import Switch from "../../../shared/components/Button/switch";
const _ = require('lodash');

const TabGeneral = (props) => {
   const { page, messageSettingGeneral, fetchMessageSettingGeneral, onChangeText, onUpdate, onChangeActive } = props;

   useEffect(() => {
      if (!_.isEmpty(page)) {
         fetchMessageSettingGeneral();
      }
   }, [page]);

   return (
      <div className="box">
         <div className="sub-content clearfix row">
            <div className="col-md-3 p-none">
               <h4 className="p-none">Lời chào</h4>
               <Switch onClick={() => onChangeActive(!messageSettingGeneral.is_actived ? 1 : 0)} isActived={!!messageSettingGeneral.is_actived} />
            </div>
            <div className="col-md-4 p-none">
               <div>
                  <div className="multiline-textbox">
                     <div className="input-text input-text-none-scrollbar text-multi reply-message text-smaller, editor">
                        <SlateEditor
                           emoji={true}
                           control={true}
                           onChange={onChangeText}
                           valueDefault={messageSettingGeneral?.text}
                           maxLength={160}
                           configControl={[PAGE_NAME, FULL_NAME, NAME, SURNAME]}
                        />
                     </div>
                  </div>
                  <div className="tutorial m-t" onClick={onUpdate}><a className="pull-right btn btn-default">Lưu</a></div>
               </div>
            </div>
            <div className="col-xs-12 col-sm-4 p-none ml20">
               <p className="function-tip section-description font-size-14">
                  Tạo lời chào mà mọi người sẽ nhìn thấy khi lần đầu tiên mở cuộc trò chuyện với bạn trên Facebook Messenger.
               </p>
            </div>
         </div>
         {/* <div className="sub-content clearfix">
            <div className="col-xs-12 col-sm-3 p-none p-r10">
               <h4 className="m-none"><span>Nhập bằng bàn phím:</span></h4>
            </div>
            <div className="col-xs-12 col-sm-4 p-none">
               <div className="input-switch input-switch-on keyboard-input-ctrl">
                  <label>
                     <div className="input-checkbox text-center checked">
                        <div className="svg-next-icon icon-check ic-check">
                        </div>
                        <div className="svg-next-icon ic-box">
                        </div>
                     </div>
                     <i></i>
                  </label>
               </div>
            </div>
            <div className="col-xs-12 col-sm-4 p-none ml20">
               <p className="function-tip section-description font-size-14">
                  Bạn có thể tắt tính năng nhập bằng bàn phím để người dùng chỉ có thể tương tác liên tục với Bot của bạn theo menu. Điều này có thể
                  hữu ích nếu bot của bạn được cấu hình cho một mục đích cụ thể hoặc một tập hợp các tùy chọn.
               </p>
            </div>
         </div> */}
         {/* <div className="sub-content clearfix collapse-setting">
            <div className="setting-general-container-collapse">
               <div className="app-collapse">
                  <div className="app-collapse-item">
                     <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="false">
                        <div
                           className="setting-gereral-collapse__title line-height-20 flex-display-justify-content-center-direction-column">
                           <div className="header-collapse-setting">
                              <div className="header-content">Thông báo lỗi khi nhập sai</div>
                           </div>
                           <div className="setting-gereral-collapse__sub-title mt4 text-no-bold">
                              <span>(Tin nhắn nhập liệu)</span>
                           </div>
                        </div>
                        <div className="app-collapse-extra">
                           <div className="display-flex align-items-center height100">
                              <div className="svg-next-icon icon-arrow-down">
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
         {/* <div className="sub-content clearfix promotion-notify-container collapse-setting">
            <div className="setting-general-container-collapse">
               <div className="app-collapse">
                  <div className="app-collapse-item">
                     <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="false">
                        <div className="setting-gereral-collapse__title line-height-20 flex-display-justify-content-center-direction-column">
                           <div className="header-collapse-setting">
                              <div className="header-content">Thông báo khi khuyến mãi hết hiệu lực:</div>
                           </div>
                        </div>
                        <div className="app-collapse-extra">
                           <div className="display-flex align-items-center height100">
                              <div className="svg-next-icon icon-arrow-down">
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
         {/* <div className="sub-content clearfix promotion-notify-container collapse-setting">
            <div className="setting-general-container-collapse">
               <div className="app-collapse">
                  <div className="app-collapse-item">
                     <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="false">
                        <div className="setting-gereral-collapse__title line-height-20 flex-display-justify-content-center-direction-column">
                           <div className="header-collapse-setting">
                              <div className="header-content">Thông báo khi gửi Thông báo định kỳ:</div>
                           </div>
                        </div>
                        <div className="app-collapse-extra">
                           <div className="display-flex align-items-center height100">
                              <div className="svg-next-icon icon-arrow-down" >
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
         {/* <div className="sub-content clearfix border-bottom row">
            <div className="col-xs-12 col-sm-3 p-none">
               <h4 className="m-none mt5">Nhập bot mẫu</h4>
            </div>
            <div className="col-xs-12 col-sm-9 p-none">
               <div className="btn-install-template-wrapper">
                  <div><button className="btn btn-primary">Nhập bot mẫu</button></div>
               </div>
            </div>
         </div> */}
         {/* <div className="sub-content clearfix border-bottom row">
            <div className="col-xs-12 col-sm-3 p-none">
               <h4 className="m-none mt5">Tắt Bot của trang này</h4>
            </div>
            <div className="col-xs-12 col-sm-8 p-none"><a className="btn btn-default text-danger">Tắt Bot</a></div>
         </div> */}
      </div>
   )
}

const mapStateToProps = (state) => {
   const { messageSettingGeneral, page } = state;
   return {
      messageSettingGeneral,
      page
   };
};

export default connect(mapStateToProps, {
   fetchMessageSettingGeneral,
   onChangeText,
   onUpdate,
   onChangeActive
})(TabGeneral);